import { Chart, registerables } from "chart.js";
import { buildChartConfig, type FulfilledRidesData } from "./buildChartConfig";

Chart.register(...registerables);

type Inputs = {
  canvasElement: HTMLCanvasElement;
  data: FulfilledRidesData;
};

export function initFulfilledRidesChart({ canvasElement, data }: Inputs): Chart {
  return new Chart(canvasElement, buildChartConfig(data));
}
